import Vue from 'vue'


//** Shared */

import Header from '@/components/shared/TheHeader'
Vue.component('GZ-Header', Header)

import Footer from '@/components/shared/TheFooter'
Vue.component('GZ-Footer', Footer)

import Content from '@/components/shared/TheContent'
Vue.component('GZ-Content', Content)

//** UI */

//Menu
import SideMenu from '@/components/ui/menu/side-menu/BaseSideMenu'
Vue.component('gz-side-menu', SideMenu)

import SideMenuItem from '@/components/ui/menu/side-menu/SideMenuItem'
Vue.component('GZ-SideMenuItem', SideMenuItem)

import TopMenu from '@/components/ui/menu/top-menu/BaseTopMenu'
Vue.component('gz-top-menu', TopMenu)

import AuthMenu from '@/components/ui/auth-menu/AuthMenu'
Vue.component('GZ-AuthMenu', AuthMenu)

//Notifications
import StaticNotification from '@/components/ui/notifications/static/BaseStaticNotification'
Vue.component('GZ-StaticNotification', StaticNotification)

import ModalNotification from '@/components/ui/notifications/modal/BaseModalNotification'
Vue.component('GZ-ModalNotification', ModalNotification)

//Modal
import Modal from '@/components/ui/modals/Modal'
Vue.component('GZ-Modal', Modal)

import ModalMainTmpl from '@/components/ui/modals/ModalMainTemplate'
Vue.component('GZ-ModalMainTmpl', ModalMainTmpl)

//Breadcurmbs
import Breadcrumbs from '@/components/ui/breadcrumbs/BaseBreadcrumbs'
Vue.component('GZ-Breadcrumbs', Breadcrumbs)

//Form
import InputContainer from '@/components/ui/forms/BaseInputContainer'
Vue.component('gz-input-container', InputContainer)

import SelectContainer from '@/components/ui/forms/SelectContainer'
Vue.component('gz-select-container', SelectContainer)

import BikLoadDataContainer from '@/components/ui/forms/BikLoadDataContainer'
Vue.component('gz-bik-load-data-container', BikLoadDataContainer)

import TextInput from '@/components/ui/forms/TextInput'
Vue.component('GZ-TextInput', TextInput)

import DateRangeInput from '@/components/ui/forms/DateRangeInput'
Vue.component('GZ-DateRangeInput', DateRangeInput)

import DateInput from '@/components/ui/forms/DateInput'
Vue.component('GZ-DateInput', DateInput)

import FileInput from '@/components/ui/forms/FileInput'
Vue.component('GZ-FileInput', FileInput)

import OptionSelect from '@/components/ui/forms/BaseOptionSelect'
Vue.component('GZ-OptionSelect', OptionSelect)

//Titles
import PageTitle from '@/components/ui/titles/BasePageTitle'
Vue.component('GZ-PageTitle', PageTitle)

import BlockTitle from '@/components/ui/titles/BaseBlockTitle'
Vue.component('GZ-BlockTitle', BlockTitle)

import PageSubtitle from '@/components/ui/titles/BasePageSubtitle'
Vue.component('GZ-PageSubtitle', PageSubtitle)

import ColTitle from '@/components/ui/titles/BaseColTitle'
Vue.component('GZ-ColTitle', ColTitle)

//Filters
import FiltersBar from '@/components/ui/filters/BaseFiltersBar'
Vue.component('gz-filters-bar', FiltersBar)

//Data
import TableDataRow from '@/components/ui/data/BaseTableDataRow'
Vue.component('GZ-TableDataRow', TableDataRow)

import TableDataCol from '@/components/ui/data/BaseTableDataCol'
Vue.component('GZ-TableDataCol', TableDataCol)

//Controls
import ExpandControl from '@/components/ui/controls/expanders/BaseExpandControl'
Vue.component('GZ-ExpandControl', ExpandControl)

import BaseButton from '@/components/ui/controls/buttons/BaseButton'
Vue.component('GZ-BaseButton', BaseButton)

//Pagination
import Pagination from '@/components/ui/pagination/Pagination'
Vue.component('GZ-Pagination', Pagination)

//Loaders
import MainLoader from '@/components/ui/loaders/BaseMainLoader'
Vue.component('GZ-MainLoader', MainLoader)

import MainPageLoader from '@/components/ui/loaders/BasePageLoader'
Vue.component('GZ-MainPageLoader', MainPageLoader)

//Authorization
import Authorization from '@/components/ui/authorization/BaseAuthorization'
Vue.component('GZ-Authorization', Authorization)

//** Includes */

import Logo from '@/components/includes/logo/BaseLogo'
Vue.component('GZ-Logo', Logo)

import Copyrights from '@/components/includes/copyrights/BaseCopyrights'
Vue.component('GZ-Copyrights', Copyrights)

//** Views */

import AuthViewTemplate from '@/components/views/auth-views/BaseAuthViewTemplate'
Vue.component('gz-auth-view-template', AuthViewTemplate)
